import React, { useEffect, useState, Fragment, useRef } from "react";
import { PageHeader } from "../../../../Common";
import services from "../services";
import $ from "jquery";
import authService from "../../../Common/services";
import { LoadingSpinerComponent } from "../../../../Common/loader";
import { trackPromise } from "react-promise-tracker";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from "@material-ui/core/TextField";
import Joi, { x } from "@hapi/joi";
import { LentLabourReportSchemaObject } from "../LentContractDetailsReportSchema";
import { validateProperty, validate } from "../../../Common";
import tokenService from "../../../../Common/tokenDecoder";
import ReactToPrint from "react-to-print";
import CreatePdf from "./createPdf";
import "../../../Common/Table/table.css";
import xlsx from "json-as-xlsx";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import Box from "@material-ui/core/Box";
import _, { isNumber } from "lodash";
import TablePagination from '@material-ui/core/TablePagination';

const screenCode = "LENTCONTRACTDETAILSREPORT";

export function LentContractDetailsReport(props) {
  const componentRef = useRef();
  const [divisions, setDivisions] = useState([]);
  const [groups, setGroups] = useState([]);
  const [estates, setEstates] = useState([]);
  const [multipleEstates, setMultipleEstates] = useState([]);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(0);
  const [totQty, setTotQty] = useState(0);
  const [totDays, setTotDays] = useState(0);
  const [isTableHide, setIsTableHide] = useState(true);
  const [lentLabourDetails, setLentLabourDetails] = useState({
    groupID: "0",
    estateID: "0",
    divisionID: "0",
    fromDate: new Date().toISOString().split('T')[0],
    toDate: new Date().toISOString().split('T')[0]
  });
  const [selectedSearchValues, setSelectedSearchValues] = useState({
    groupID: "0",
    estateID: "0",
    division: "0",
    fromDate: "",
    toDate: "",
  });

  const [errors, setErrors] = useState({});

  const [permissionList, setPermissions] = useState({
    isAddEditEnabled: false,
    isGroupFilterEnabled: false,
    isOperationEntityFilterEnabled: false,
  });

  const [isReportButtonsEnabled, setIsReportButtonsEnabled] = useState(false);
  const [buttonHide, setButtonHide] = useState(true);

  const handleLimitChange = (event) => {
    setLimit(event.target.value);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const schema = Joi.object(LentLabourReportSchemaObject).options({
    allowUnknown: true,
  });

  const [csvHeaders, setCsvHeaders] = useState([
    { label: "Arival Date", value: "date" },
    { label: "Lent Field Number", value: "fieldName" },
    { label: "Lent RS Sub Block", value: "subBlock" },
    { label: "Block Owner Name", value: "blockOwnerName" },
    { label: "Lent Supplier Number\Reg Number", value: "supplierRegNo" },
    { label: "Lent Supplier\Reg Worker Name", value: "workerName" },
    { label: "Qty Plucked", value: "qty" },
    { label: "Operator", value: "userName" },
  ]);

  const [reportData, setReportData] = useState([]);

  useEffect(() => {
    trackPromise(getPermissions(), getGroupsForDropdown());
  }, []);

  useEffect(() => {
    trackPromise(getEstatesForDropdown());
  }, [lentLabourDetails.groupID]);

  useEffect(() => {
    trackPromise(getDivisionsForDropDown());
  }, [lentLabourDetails.estateID]);

  useEffect(() => {
    setReportData([]);
  }, [lentLabourDetails.groupID, lentLabourDetails.estateID, lentLabourDetails.divisionID, lentLabourDetails.fromDate, lentLabourDetails.toDate]);

  useEffect(() => { }, [reportData]);

  function handleGroupChange(target) {
    validateInputs(target);

    setLentLabourDetails({
      ...lentLabourDetails,
      groupID: target.value,
      estateID: "0",
      fieldID: "0",
    });
  }

  function handleEstateChange(target) {
    validateInputs(target);

    setLentLabourDetails({
      ...lentLabourDetails,
      estateID: target.value,
    });
  }
  function handleDivisionChange(target) {
    validateInputs(target);

    setLentLabourDetails({
      ...lentLabourDetails,
      divisionID: target.value,
    });
  }

  function handleFromDateChange(target) {
    validateInputs(target);

    setLentLabourDetails({
      ...lentLabourDetails,
      fromDate: target.value,
    });
  }

  function handleToDateChange(target) {
    validateInputs(target);

    setLentLabourDetails({
      ...lentLabourDetails,
      toDate: target.value,
    });
  }

  function validateInputs(target) {
    const error = { ...errors };
    const errorMessage = validateProperty(
      target,
      LentLabourReportSchemaObject
    );
    errorMessage
      ? (error[target.name] = errorMessage)
      : delete error[target.name];

    setErrors(error);
  }

  async function getPermissions() {
    var permissions = await authService.getPermissionsByScreen(screenCode);

    var isAuthorized = permissions.find(
      (p) => p.permissionCode == "VIEWLENTCONTRACTDETAILSREPORT"
    );

    if (isAuthorized === undefined) {
      props.history.push("/unauthorized");
    }
    var isGroupFilterEnabled = permissions.find(
      (p) => p.permissionCode == "GROUPDROPDOWN"
    );

    var isOperationEntityFilterEnabled = permissions.find(
      (p) => p.permissionCode == "OPERATIONENTITYDROPDOWN"
    );

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isOperationEntityFilterEnabled:
        isOperationEntityFilterEnabled !== undefined,
    });
    var token = tokenService.getUserDetailsFromTokenV2();

    if (token.operationEntities.length > 0) {

      var estateArray = [];
      for (let item of Object.entries(token.operationEntities)) {
        estateArray[item[1]["OperationEntityID"]] = item[1]["OperationEntityName"]
      }

      setMultipleEstates(estateArray)

      setLentLabourDetails({
        ...lentLabourDetails,
        groupID: token.groupID
      });

    } else {
      setLentLabourDetails({
        ...lentLabourDetails,
        groupID: token.groupID,
        estateID: token.operationEntityID,
      });
    }

    setLentLabourDetails({
      ...lentLabourDetails,
      groupID: token.groupID,
      estateID: token.operationEntityID,
    });
    trackPromise(getGroupsForDropdown());
  }

  async function getGroupsForDropdown() {
    const result = await services.getAlGroupsForDropdown();
    setGroups(result);
  }

  async function getEstatesForDropdown() {
    const data = await services.getEstatesByGroupID(
      lentLabourDetails.groupID
    );
    setEstates(data);
  }

  async function getDivisionsForDropDown() {
    const data = await services.getDivisionByEstateID(
      lentLabourDetails.estateID
    );
    setDivisions(data);
  }

  function generateDropDownMenu(data) {
    let items = [];
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(
          <MenuItem key={key} value={key}>
            {value}
          </MenuItem>
        );
      }
    }
    return items;
  }

  async function handleSearch(e) {
    e.preventDefault();
    setIsTableHide(true);

    const errorMessages = validate(schema, lentLabourDetails)
    errorMessages !== null ? setErrors(errorMessages) : setErrors({})
    if (errorMessages) return;

    getSelectedDropdownValuesForReport(lentLabourDetails);
    var reportData = await services.getLentContractDetailsReportData(lentLabourDetails);

    setReportData(reportData);
    console.log(reportData)
    let totQty = 0;
    reportData.forEach(x => {
      totQty = x.qty + totQty;
    });
    setTotQty(totQty)

    const groupedData = reportData.reduce((acc, item) => {
      if (!acc[item.date.split('T')[0]]) {
        acc[item.date.split('T')[0]] = [];
      }
      acc[item.date.split('T')[0]].push(item);
      return acc;
    }, {});
    setTotDays(Object.keys(groupedData).length)

    setIsTableHide(false);
    destroyDataTable();
    setIsReportButtonsEnabled(true);
    setButtonHide(false);
  }


  function createFile() {
    var settings = {
      sheetName: "Lent Contract Details Report",
      fileName: "Lent Contract Details Report",
      writeOptions: {},
    };

    var copyOfCsv = _.cloneDeep(reportData);

    copyOfCsv.push({});
    copyOfCsv.push({
      date: "Total Qty :",
      qty: "" + totQty,
    });
    copyOfCsv.push({
      date: "Total Days :",
      qty: "" + totDays,
    });

    copyOfCsv.push({});

    copyOfCsv.push({
      date: "Group :" + groups[lentLabourDetails.groupID],
      fieldName: "Estate : " + estates[lentLabourDetails.estateID],
      subBlock: "Division : " + divisions[lentLabourDetails.divisionID],
      blockOwnerName: "From Date : " + lentLabourDetails.fromDate,
      supplierRegNo: "To Date : " + lentLabourDetails.toDate,
    });

    xlsx(csvHeaders, copyOfCsv, settings, true);
  }

  function destroyDataTable() {
    $("#example3").DataTable().destroy();
  }

  function onCancelClick() {
    clearState();
  }

  function clearState() {
    setLentLabourDetails({
      ...lentLabourDetails,
      fromDate: "",
      toDate: ""
    });
    setReportData([]);
    setIsTableHide(true);
    setErrors("");
    setIsReportButtonsEnabled(false);
  }

  function getSelectedDropdownValuesForReport(searchForm) {
    setSelectedSearchValues({
      ...selectedSearchValues,
      group: groups[searchForm.groupID],
      estate: estates[searchForm.estateID],
      division: divisions[searchForm.divisionID],
      fromDate: searchForm.fromDate,
      toDate: searchForm.toDate,
    });
  }

  return (
    <Fragment>
      <LoadingSpinerComponent />
      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <PageHeader
              title="Lent Contract Details Report"
              isButtonEnable={permissionList.isAddEditEnabled}
            />
            <div className="card-body">
              <form onSubmit={(e) => handleSearch(e)} disabled={false}>
                <div className="form-group row">
                  <div className="col-md-3">
                    <InputLabel shrink id="groupID">
                      Group *
                    </InputLabel>
                    <Select
                      fullWidth
                      labelId="groupID"
                      id="groupID"
                      name="groupID"
                      value={lentLabourDetails.groupID}
                      disabled={!permissionList.isGroupFilterEnabled}
                      onChange={(e) => handleGroupChange(e.target)}
                    >
                      <MenuItem value="0">--Select Group--</MenuItem>
                      {generateDropDownMenu(groups)}
                    </Select>
                    {errors["groupID"] && (
                      <FormHelperText error>{errors["groupID"]}</FormHelperText>
                    )}
                  </div>
                  <div className="col-md-3">
                    <InputLabel shrink id="estateID">
                      Estate *
                    </InputLabel>
                    <Select
                      fullWidth
                      labelId="estateID"
                      id="estateID"
                      name="estateID"
                      value={lentLabourDetails.estateID}
                      disabled={!permissionList.isOperationEntityFilterEnabled}
                      onChange={(e) => handleEstateChange(e.target)}
                    >
                      <MenuItem value="0">--Select Estate--</MenuItem>
                      {generateDropDownMenu(multipleEstates.length == 0 ? estates : multipleEstates)}
                    </Select>
                    {errors["estateID"] && (
                      <FormHelperText
                        id="errbranchCode"
                        className="text text-danger"
                      >
                        {errors["estateID"]}
                      </FormHelperText>
                    )}
                  </div>
                  <div className="col-md-3">
                    <InputLabel shrink id="">
                      Division*
                    </InputLabel>
                    <Select
                      fullWidth
                      labelId="divisionID"
                      id="divisionID"
                      name="divisionID"
                      value={lentLabourDetails.divisionID}
                      onChange={(e) => handleDivisionChange(e.target)}
                    >
                      <MenuItem value="0">--Select Division--</MenuItem>
                      {generateDropDownMenu(divisions)}
                    </Select>
                    {errors["divisionID"] && (
                      <FormHelperText
                        id="errbranchCode"
                        className="text text-danger"
                      >
                        {errors["divisionID"]}
                      </FormHelperText>
                    )}
                  </div>
                  <div className="col-md-3">
                    <InputLabel shrink id="fromDate">
                      From Date *
                    </InputLabel>
                    <TextField
                      fullWidth
                      id="fromDate"
                      name="fromDate"
                      type="date"
                      value={lentLabourDetails.fromDate}
                      maxDate={new Date()}
                      onChange={(e) => handleFromDateChange(e.target)}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                    {errors["fromDate"] && (
                      <FormHelperText
                        id="errbranchCode"
                        className="text text-danger"
                      >
                        {errors["fromDate"]}
                      </FormHelperText>
                    )}
                  </div>
                  <div className="col-md-3">
                    <InputLabel shrink id="toDate">
                      To Date *
                    </InputLabel>
                    <TextField
                      fullWidth
                      id="toDate"
                      name="toDate"
                      type="date"
                      value={lentLabourDetails.toDate}
                      maxDate={new Date()}
                      onChange={(e) => handleToDateChange(e.target)}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                    {errors["toDate"] && (
                      <FormHelperText
                        id="errbranchCode"
                        className="text text-danger"
                      >
                        {errors["toDate"]}
                      </FormHelperText>
                    )}
                  </div>
                </div>
                <div className="card-footer">
                  <input
                    disabled={validate(schema, lentLabourDetails)}
                    type="button"
                    className="btn btn-primary"
                    value="Search"
                    onClick={(e) => trackPromise(handleSearch(e))}
                  />
                  <input
                    type="reset"
                    className="btn btn-warning pull-right"
                    value="Clear"
                    onClick={onCancelClick}
                  />
                </div>
              </form>

              {reportData.length != 0 ? (
                <div>
                  <div className="row">
                    <div className="col-md-12">
                      <div>
                        <Box display="flex" justifyContent="flex-end" p={2}>
                          <TableContainer component={Paper} style={{ border: "2px solid black", maxHeight: '700px',overflowY: 'auto'}}>
                            <Table style={{ borderCollapse: 'collapse', border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} size="small" aria-label="sticky table" stickyHeader>
                              <TableHead>
                                <TableRow style={{ border: "2px solid black" }}>
                                  <TableCell align="center" style={{ fontWeight: "bold", border: "2px solid black" }}>Arival Date</TableCell>
                                  <TableCell align="center" style={{ fontWeight: "bold", border: "2px solid black" }}>Lent Field Number</TableCell>
                                  <TableCell align="center" style={{ fontWeight: "bold", border: "2px solid black" }}>Lent RS Sub Block</TableCell>
                                  <TableCell align="center" style={{ fontWeight: "bold", border: "2px solid black" }}>Block Owner Name</TableCell>
                                  <TableCell align="center" style={{ fontWeight: "bold", border: "2px solid black" }}>Lent Supplier Number\Reg Number</TableCell>
                                  <TableCell align="center" style={{ fontWeight: "bold", border: "2px solid black" }}>Lent Supplier\Reg Worker Name</TableCell>
                                  <TableCell align="center" style={{ fontWeight: "bold", border: "2px solid black" }}>Qty Plucked</TableCell>
                                  <TableCell align="center" style={{ fontWeight: "bold", border: "2px solid black" }}>Operator</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody >
                              {reportData.slice(page * limit, page * limit + limit).map((row, i) => (
                                  <TableRow key={i} style={{ border: "2px solid black" }}>
                                    <TableCell component="th" scope="row" align="center" style={{ border: "2px solid black" }}>{row.date.split('T')[0]}</TableCell>
                                    <TableCell component="th" scope="row" align="left" style={{ border: "2px solid black" }}>{row.fieldName}</TableCell>
                                    <TableCell component="th" scope="row" align="left" style={{ border: "2px solid black" }}>{row.subBlock}</TableCell>
                                    <TableCell component="th" scope="row" align="left" style={{ border: "2px solid black" }}>{row.blockOwnerName}</TableCell>
                                    <TableCell component="th" scope="row" align="left" style={{ border: "2px solid black" }}>{row.supplierRegNo}</TableCell>
                                    <TableCell component="th" scope="row" align="left" style={{ border: "2px solid black" }}>{row.workerName}</TableCell>
                                    <TableCell component="th" scope="row" align="right" style={{ border: "2px solid black" }}>{row.qty}</TableCell>
                                    <TableCell component="th" scope="row" align="right" style={{ border: "2px solid black" }}>{row.userName}</TableCell>
                                  </TableRow>
                                ))}
                                <TableRow style={{ border: "2px solid black", tableLayout: 'fixed' }}>
                                  <TableCell component="th" scope="row" align="left" style={{ fontWeight: "bold", border: "2px solid black" }} colSpan={6}>Total Qty</TableCell>
                                  <TableCell component="th" scope="row" align="right" style={{ fontWeight: "bold", border: "2px solid black" }}>{totQty}</TableCell>
                                </TableRow>
                                <TableRow style={{ border: "2px solid black" }}>
                                  <TableCell component="th" scope="row" align="left" style={{ fontWeight: "bold", border: "2px solid black" }} colSpan={6}>Total Days</TableCell>
                                  <TableCell component="th" scope="row" align="right" style={{ fontWeight: "bold", border: "2px solid black" }}>{totDays}</TableCell>
                                </TableRow>
                              </TableBody>
                            </Table>
                            <TablePagination
                              component="div"
                              count={reportData.length}
                              onChangePage={handlePageChange}
                              onChangeRowsPerPage={handleLimitChange}
                              page={page}
                              rowsPerPage={limit}
                              rowsPerPageOptions={[5, 10, 25]}
                            />
                          </TableContainer>
                        </Box>
                      </div>
                    </div>
                  </div>
                </div>
              ) : null}
            </div>
            {reportData.length != 0 ? (
              <div className="pt-2">
                <ReactToPrint
                  trigger={() => (
                    <input
                      type="button"
                      className="btn btn-primary pull-right ml-2"
                      value="PDF"
                    />
                  )}
                  content={() => componentRef.current}
                />
                <div hidden={true}>
                  <CreatePdf
                    ref={componentRef}
                    reportData={reportData}
                    searchData={selectedSearchValues}
                  />
                </div>{" "}
                <input
                  type="button"
                  className="btn btn-primary pull-right ml-2"
                  value="Excel"
                  onClick={createFile}
                />
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </Fragment>
  );
}
